module.exports = __webpack_public_path__ + "img/menu_mens_dermapen.d621bf8e.png";